import { trpc } from "@mnk/frontend/lib/trpc";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import { useState } from "react";
import { OfficeCardView } from "./CardView";
import { OfficeListView } from "./ListView";

export const OfficesList = () => {
  const [view, setView] = useState<"list" | "card">("list");

  const getOffices = trpc.getAvailableOffices.useQuery();
  const offices = getOffices.data;

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="flex items-center justify-between p-4 border-b border-gray-200 mb-4">
        <p className="text-xl font-bold">事業所一覧</p>
        <div className="flex items-center gap-2">
          <ListIcon
            className={`cursor-pointer text-gray-800 ${view === "list" ? "fill-blue-500" : ""}`}
            onClick={() => setView("list")}
          />
          <GridViewIcon
            className={`cursor-pointer text-gray-800 ${view === "card" ? "fill-blue-500" : ""}`}
            onClick={() => setView("card")}
          />
        </div>
      </div>
      {view === "list" ? <OfficeListView offices={offices ?? []} /> : <OfficeCardView offices={offices ?? []} />}
    </div>
  );
};
